import { TRIOLIET_BORDER_RADIUS, TRIOLIET_BOX_SHADOW, TRIOLIET_COLORS, TRIOLIET_FONTS, TRIOLIET_LAYOUT, TRIOLIET_SPACING, } from './triolietThemeConf';
import { createTheme } from '@material-ui/core/styles';
import { border, toCssValue } from '../themeUtils';
const triolietThemeConf = {
    color: {
        primary: {
            lightest: TRIOLIET_COLORS.primary.lightest,
            light: TRIOLIET_COLORS.primary.light,
            main: TRIOLIET_COLORS.primary.main,
            dark: TRIOLIET_COLORS.primary.dark,
            darkest: TRIOLIET_COLORS.primary.darkest,
        },
        brand: {
            lightest: TRIOLIET_COLORS.brand.lightest,
            light: TRIOLIET_COLORS.brand.light,
            main: TRIOLIET_COLORS.brand.main,
            dark: TRIOLIET_COLORS.brand.dark,
            darkest: TRIOLIET_COLORS.brand.darkest,
        },
        success: {
            light: TRIOLIET_COLORS.success.light,
            main: TRIOLIET_COLORS.success.main,
            dark: TRIOLIET_COLORS.success.dark,
        },
        error: {
            lightest: TRIOLIET_COLORS.error.lightest,
            light: TRIOLIET_COLORS.error.light,
            main: TRIOLIET_COLORS.error.main,
            dark: TRIOLIET_COLORS.error.dark,
        },
        warning: {
            lightest: TRIOLIET_COLORS.warning.lightest,
            light: TRIOLIET_COLORS.warning.light,
            main: TRIOLIET_COLORS.warning.main,
        },
        grey: {
            lightest: TRIOLIET_COLORS.grey.lightest,
            light: TRIOLIET_COLORS.grey.light,
            default: TRIOLIET_COLORS.grey.default,
            dark: TRIOLIET_COLORS.grey.dark,
            darkest: TRIOLIET_COLORS.grey.darkest,
        },
        input: {
            placeholder: TRIOLIET_COLORS.grey.default,
            border: TRIOLIET_COLORS.grey.default,
        },
        background: {
            body: TRIOLIET_COLORS.background.body,
            light: TRIOLIET_COLORS.background.light,
            dark: TRIOLIET_COLORS.background.dark,
        },
        font: {
            dark: TRIOLIET_COLORS.font.dark,
            light: TRIOLIET_COLORS.font.light,
        },
        common: {
            contentHover: TRIOLIET_COLORS.common.contentHover,
        },
    },
    font: {
        family: TRIOLIET_FONTS.family,
        size: {
            small: TRIOLIET_FONTS.size.small,
            mediumSmall: TRIOLIET_FONTS.size.mediumSmall,
            medium: TRIOLIET_FONTS.size.medium,
            mediumBig: TRIOLIET_FONTS.size.mediumBig,
            big: TRIOLIET_FONTS.size.big,
            caption: TRIOLIET_FONTS.size.caption,
            title: TRIOLIET_FONTS.size.title,
            heading: TRIOLIET_FONTS.size.heading,
        },
        lineHeight: {
            small: TRIOLIET_FONTS.lineHeight.small,
            mediumSmall: TRIOLIET_FONTS.lineHeight.mediumSmall,
            medium: TRIOLIET_FONTS.lineHeight.medium,
            mediumBig: TRIOLIET_FONTS.lineHeight.mediumBig,
            big: TRIOLIET_FONTS.lineHeight.big,
        },
        weight: {
            light: TRIOLIET_FONTS.weight.light,
            normal: TRIOLIET_FONTS.weight.normal,
            bold: TRIOLIET_FONTS.weight.bold,
        },
    },
    common: {
        borderRadius: {
            low: TRIOLIET_BORDER_RADIUS.low,
            default: TRIOLIET_BORDER_RADIUS.default,
            high: TRIOLIET_BORDER_RADIUS.high,
            onlyTop: TRIOLIET_BORDER_RADIUS.onlyTop,
            onlyRight: TRIOLIET_BORDER_RADIUS.onlyRight,
        },
        shadow: {
            light: TRIOLIET_BOX_SHADOW.light,
            default: TRIOLIET_BOX_SHADOW.default,
            dark: TRIOLIET_BOX_SHADOW.dark,
        },
    },
    space: {
        layout: {
            fullWidth: TRIOLIET_SPACING.layout.fullWidth,
            partialWidth: TRIOLIET_SPACING.layout.partialWidth,
        },
        margin: {
            smallest: TRIOLIET_SPACING.margin.smallest,
            small: TRIOLIET_SPACING.margin.small,
            default: TRIOLIET_SPACING.margin.default,
            large: TRIOLIET_SPACING.margin.large,
            largest: TRIOLIET_SPACING.margin.largest,
            horizontalDefault: TRIOLIET_SPACING.margin.horizontalDefault,
            verticalDefault: TRIOLIET_SPACING.margin.verticalDefault,
        },
        padding: {
            smallest: TRIOLIET_SPACING.padding.smallest,
            small: TRIOLIET_SPACING.padding.small,
            default: TRIOLIET_SPACING.padding.default,
            large: TRIOLIET_SPACING.padding.large,
            largest: TRIOLIET_SPACING.padding.largest,
            horizontalDefault: TRIOLIET_SPACING.padding.horizontalDefault,
            verticalDefault: TRIOLIET_SPACING.padding.verticalDefault,
        },
    },
    layout: {
        width: {
            full: TRIOLIET_LAYOUT.width.full,
            partial: TRIOLIET_LAYOUT.width.partial,
        },
        sidebar: {
            full: TRIOLIET_LAYOUT.sidebar.full,
        },
        header: {
            topBar: TRIOLIET_LAYOUT.header.topBar,
            menu: TRIOLIET_LAYOUT.header.menu,
        },
    },
    components: {
        table: {
            header: {
                background: TRIOLIET_COLORS.primary.light,
                color: TRIOLIET_COLORS.font.dark,
            },
            headerSecondary: {
                background: TRIOLIET_COLORS.primary.light,
                color: TRIOLIET_COLORS.font.dark,
            },
            th: {
                background: TRIOLIET_COLORS.background.light,
                color: TRIOLIET_COLORS.font.dark,
            },
            row: {
                hover: TRIOLIET_COLORS.common.contentHover,
            },
        },
        link: {
            colors: {
                normal: TRIOLIET_COLORS.primary.darkest,
                hover: TRIOLIET_COLORS.primary.light,
            },
        },
        header: {
            colors: {
                background: TRIOLIET_COLORS.primary.light,
                text: TRIOLIET_COLORS.font.dark,
                menuIcon: TRIOLIET_COLORS.font.dark,
            },
        },
        menu: {
            colors: {
                background: TRIOLIET_COLORS.background.light,
                text: TRIOLIET_COLORS.font.dark,
                selected: TRIOLIET_COLORS.accent.main,
            },
        },
        userMenu: {
            colors: {
                headerBackground: TRIOLIET_COLORS.primary.light,
                headerText: TRIOLIET_COLORS.font.dark,
                buttonBackground: TRIOLIET_COLORS.background.light,
                buttonText: TRIOLIET_COLORS.font.dark,
                buttonBackgroundHover: TRIOLIET_COLORS.primary.main,
                triggerBackground: TRIOLIET_COLORS.background.light,
                triggerText: TRIOLIET_COLORS.font.dark,
                userIconBackground: TRIOLIET_COLORS.background.light,
                userIconText: TRIOLIET_COLORS.font.dark,
            },
        },
        tabs: {
            indicator: TRIOLIET_COLORS.accent.main,
            background: TRIOLIET_COLORS.primary.light,
            color: TRIOLIET_COLORS.font.dark,
        },
        listItem: {
            backgroundHover: TRIOLIET_COLORS.background.light,
            backgroundSelected: TRIOLIET_COLORS.primary.light,
            textHover: TRIOLIET_COLORS.font.dark,
            textSelected: TRIOLIET_COLORS.font.dark,
        },
        sidebar: {
            colors: {
                itemSelected: TRIOLIET_COLORS.accent.main,
                border: TRIOLIET_COLORS.primary.light,
            },
        },
        passwordSuggestionBox: {
            container: {
                background: TRIOLIET_COLORS.background.light,
                text: TRIOLIET_COLORS.font.dark,
            },
            arrow: {
                background: TRIOLIET_COLORS.background.light,
            },
            rule: {
                iconSuccess: TRIOLIET_COLORS.success.main,
                iconError: TRIOLIET_COLORS.error.main,
                text: TRIOLIET_COLORS.font.dark,
            },
        },
        logoutButton: {
            background: TRIOLIET_COLORS.primary.light,
            backgroundHover: TRIOLIET_COLORS.primary.light,
            text: TRIOLIET_COLORS.font.light,
        },
    },
};
export function createMyTheme(options) {
    return createTheme({
        palette: {
            primary: {
                light: TRIOLIET_COLORS.primary.light,
                main: TRIOLIET_COLORS.primary.main,
                dark: TRIOLIET_COLORS.primary.dark,
            },
            secondary: {
                light: TRIOLIET_COLORS.primary.light,
                main: TRIOLIET_COLORS.primary.main,
                dark: TRIOLIET_COLORS.primary.dark,
            },
            text: {
                primary: TRIOLIET_COLORS.font.dark,
                secondary: TRIOLIET_COLORS.font.dark,
            },
        },
        typography: {
            fontFamily: TRIOLIET_FONTS.family,
            h5: {
                fontSize: '1.25rem',
                lineHeight: '1.5',
            },
            subtitle1: {
                lineHeight: '1.25',
            },
            body1: {
                color: '#4a4a4a',
            },
            caption: {
                color: '#333',
                fontSize: '0.625rem',
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                color: 'black',
            },
        },
        overrides: {
            MuiAppBar: {
                root: {
                    'header & .MuiToolbar-root:before': {
                        content: "''",
                        position: 'absolute',
                        left: '-30px',
                        top: '0',
                        bottom: '0',
                        width: '125px',
                        transform: 'skewX(-45deg)',
                        background: 'white',
                    },
                },
            },
            MuiAutocomplete: {
                noOptions: {
                    color: TRIOLIET_COLORS.font.dark,
                    fontSize: TRIOLIET_FONTS.size.medium,
                },
            },
            MuiInput: {
                underline: {
                    '&:after, &:before': {
                        borderBottom: border('currentColor'),
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottomColor: 'currentColor',
                    },
                },
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 2,
                    fontSize: '0.70rem',
                    lineHeight: '0.9em',
                },
            },
            MuiFormLabel: {
                root: {
                    color: TRIOLIET_COLORS.grey.light,
                    '&$disabled': {
                        color: TRIOLIET_COLORS.font.dark,
                    },
                    '&$focused': {
                        color: TRIOLIET_COLORS.font.dark,
                    },
                },
            },
            MuiInputLabel: {
                formControl: {
                    color: TRIOLIET_COLORS.font.dark,
                },
            },
            MuiStepLabel: {
                root: {
                    textTransform: 'uppercase',
                },
                label: {
                    color: TRIOLIET_COLORS.font.dark,
                },
                completed: {
                    '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    },
                },
                active: {
                    fontWeight: `${TRIOLIET_FONTS.weight.bold} !important`,
                },
                '&$disabled': {
                    color: TRIOLIET_COLORS.grey.light,
                },
            },
            MuiStepIcon: {
                root: {
                    '& text': {
                        fill: TRIOLIET_COLORS.font.light,
                        fontSize: TRIOLIET_FONTS.size.mediumSmall,
                        fontWeight: TRIOLIET_FONTS.weight.bold,
                    },
                },
                completed: {
                    color: `${TRIOLIET_COLORS.primary.light} !important`,
                },
                active: {
                    color: `${TRIOLIET_COLORS.primary.light} !important`,
                },
            },
            MuiTooltip: {
                tooltip: {
                    color: `${TRIOLIET_COLORS.font.dark} !important`,
                    backgroundColor: `${TRIOLIET_COLORS.primary.light} !important`,
                },
                arrow: {
                    color: `${TRIOLIET_COLORS.primary.light}`,
                },
            },
            MuiTab: {
                root: {
                    color: TRIOLIET_COLORS.font.dark,
                    '&$selected': {
                        color: TRIOLIET_COLORS.font.dark,
                        background: TRIOLIET_COLORS.primary.light,
                    },
                },
                textColorPrimary: {
                    color: TRIOLIET_COLORS.font.dark,
                    '&$selected': {
                        color: TRIOLIET_COLORS.font.dark,
                    },
                },
            },
            MuiTabPanel: {
                root: {
                    background: TRIOLIET_COLORS.background.light,
                },
            },
            MuiInputBase: {
                input: {
                    padding: toCssValue([7, 0, 2]),
                    fontSize: TRIOLIET_FONTS.size.mediumBig,
                },
            },
            MuiRadio: {
                root: {
                    color: TRIOLIET_COLORS.font.dark,
                },
            },
            MuiSelect: {
                select: {
                    padding: toCssValue([7, 0, 6]),
                },
            },
        },
        ...options,
    });
}
export const triolietTheme = createMyTheme(triolietThemeConf);
//# sourceMappingURL=triolietTheme.js.map